/**
 * Created by Jie Gao on 2018-06-14.
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GGInitialWinCountUp} from "../../winpresentation/initial/GGInitialWinCountUp";
import {TimelineLite, TweenLite} from "gsap";
import {FontStyleConfig} from "../../config/FontStyleConfig";
import {GGGameMode} from "../../gamemode/GGGameMode";
import {CoinsFountain} from "./CoinsFountain";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {cloneScreenBounds, ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";

export class GGFreespinOutroView extends ScreenView {

    private readonly stagesFS:number[] = [6, 25, 50, 100, 200];
    private readonly stagesSFS:number[] = [30, 40, 50, 100, 200];
    private _container:PIXI.Container;
    private _infoPanel:PIXI.Container;
    private _spinsPlayed:PIXI.Text;
    private _dimmer:PIXI.Sprite;
    private _winCountUp:GGInitialWinCountUp;
    private _winAnimation:PIXI.Sprite;
    private _winPrince:PIXI.spine.Spine;
    private _loseAnimation:PIXI.spine.Spine;
    private _loseLoop:PIXI.spine.Spine;
    private _coinRain:CoinsFountain;
    private _totalWin:number;
    private _tl:TimelineLite | null;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
        this._winCountUp = new GGInitialWinCountUp(FontStyleConfig.CountUp);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container();
        this._infoPanel = new PIXI.Container();
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.anchor.set(0.5, 0.5);
        this._dimmer.position.set(0, 0);
        this._dimmer.tint = 0X000000;
        this._dimmer.alpha = 0.7;
        container.addChild(this._dimmer);
        this._coinRain = new CoinsFountain();
        container.addChild(this._coinRain);
        this._spinsPlayed = new PIXI.Text("", {
            dropShadow : true,
            dropShadowAngle : 1.2,
            dropShadowBlur : 5,
            dropShadowDistance : 12,
            dropShadowColor : "#000000",
            fontFamily : "Open Sans",
            fontWeight : FontWeight.EXTRA_BOLD,
            align : "center",
            fontSize : 36,
            fill : [
                "white",
            ],
            wordWrap : true,
            wordWrapWidth : 680
        });
        this._spinsPlayed.anchor.set(0.5);

        this.reset();
        this._winCountUp.position.set(0, 100);
        this._infoPanel.addChild(this._spinsPlayed);
        this._infoPanel.addChild(this._winCountUp);
        container.addChild(this._infoPanel);
        this._container = container;
        return container;
    }

    private createSpine(name:string, pos:[number, number]):PIXI.spine.Spine {
        const spineAnimation:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(name));
        spineAnimation.name = name;
        spineAnimation.position.set(pos[0], pos[1]);
        spineAnimation.renderable = false;
        this._infoPanel.addChild(spineAnimation);
        return spineAnimation;
    }

    protected onResizeButtons(resizeData:IResizeData):void {
        // resize together with onResizeGameGraphics
    }

    protected setButtonPosition():void {
        this._button.position.x = 360;
        if(NolimitApplication.isLandscape) {
            this._button.position.y = 615;
        } else {
            const bounds:ScreenBounds = cloneScreenBounds(NolimitApplication.screenBounds);
            this._button.position.y = (bounds.bottom - 610) * 0.5 + 610;
        }
    }

    protected onButtonClick():void {
        super.onButtonClick();
        this._button.enabled = false;
        GGGameModuleConfig.soundPlayer.playFsButtonClickSound();
        GGGameModuleConfig.featurePrice.reset();
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        const screenHeight:number = NolimitApplication.screenBounds.height;
        this._container.position.set(360, 360);
        this._coinRain.position.set(0, 0 - screenHeight * 0.5 - 30);
        this._dimmer.width = resizeData.width + 100;
        this._dimmer.height = screenHeight + 100;

        // #492
        this._spinsPlayed.position.y = (NolimitApplication.isLandscape ? 195 : 230);
    }

    protected startPresentation(data:ParsedGameData, onShowComplete:() => void):void {
        this.alpha = 0;
        this._totalWin = data.totalWin;
        const isSuperFS:boolean = (data.mode === GGGameMode.FREESPIN_SUPER);
        const currentWinsBetX:number = (isSuperFS ? 30 : 6);
        const ratio:number = Math.floor(data.totalWin / data.playedBetValue);
        let hasWon:boolean = ratio >= currentWinsBetX;
        const level:number = this.getWinLevel(ratio, isSuperFS ? this.stagesSFS : this.stagesFS);
        const spinsPlayed:number = ((<ParsedGameData>data).numberOfFreespinsPlayed! < 1) ? 3 : (<ParsedGameData>data).numberOfFreespinsPlayed!
        this.checkAnimation();

        // #531
        this.resetGraphics();
        this._spinsPlayed.text = ` ${Translation.translate("Spins played: ")} ${spinsPlayed.toString()} `;

        const tl: TimelineLite = new TimelineLite({
                paused: true
            }),
            // #447
            totalWinBelowStake: boolean = GGGameModuleConfig.featurePrice.isWinBelowStake();

        // https://github.com/nolimitcity/nolimit-slot-launcher/issues/397
        if (hasWon) {
            hasWon = !totalWinBelowStake;
        }

        tl.add([
            TweenLite.fromTo(this, 1, {alpha: 0}, {alpha: 1}),
            () => {
                // #447
                if (!totalWinBelowStake) {
                    GGGameModuleConfig.soundPlayer.playFsOutroSound(hasWon);
                }
            }
        ], 0);

        tl.add(() => GGGameModuleConfig.soundPlayer.stopFSMusic(), 1);

        if(hasWon) {
            tl.add([
                () => {
                    this._winPrince.scale.set(0.9, 0.9);
                    this._winAnimation.scale.set(0.9, 0.9);
                    this._winPrince.renderable = true;
                    this._winAnimation.visible = true;
                    this._spinsPlayed.visible = false;
                    this._winPrince.state.setAnimation(0, "Prince_Loop", true);
                    this._winCountUp.visible = true;
                    this._coinRain.play(level);
                },
                TweenLite.fromTo(this._winAnimation.scale, 4, {x : 0.9, y : 0.9}, {x : 1.1, y : 1.1}),
                TweenLite.fromTo(this._winPrince.scale, 4, {x : 0.9, y : 0.9}, {x : 1.1, y : 1.1}),
                this._winCountUp.getCountUpAnimation(0, data.totalWin, 2.4)
            ]);
            tl.add(() => {
                this._spinsPlayed.visible = true;
                GGGameModuleConfig.soundPlayer.playFsOutroCoinEndSound();
            }, 3.4);
        } else {
            tl.add([
                () => {
                    if(data.totalWin > 0) {
                        this._winCountUp.visible = true;
                        this._winCountUp.getCountUpAnimation(0, data.totalWin, 0);
                    }
                    this._loseLoop.renderable = true;
                    this._loseAnimation.renderable = true;
                    this._loseLoop.state.setAnimation(0, "Outro_Loop", true);
                    this._loseAnimation.state.setAnimation(0, "Characters", false);

                    this._spinsPlayed.visible = true;
                }
            ]);
        }

        tl.add(() => {
            this._button.visible = true;
            super.startPresentation(data, onShowComplete);
        }, (hasWon ? 4 : 1)); // #531
        this._tl = tl;
        tl.play(0);
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const tl:TimelineLite = new TimelineLite({
            paused : true
        });
        tl.add(TweenLite.fromTo(this, 0.5, {alpha : 1}, {alpha : 0}), 0);
        tl.add(() => super.stopPresentation(closeCallback));
        tl.play(0);
    }

    private getWinLevel(ratio:number, stages:number[]):number {
        let level:number = 1;
        stages.forEach((levelRatio:number, i:number) => {
            if(ratio >= levelRatio) {
                level = i + 1
            }
        });
        return level;
    }

    private checkAnimation():void {
        if(!this._winPrince) {
            this._winPrince = this.createSpine("Prince_FS", [0, -56]);
            this._winAnimation = new PIXI.Sprite(GameResources.getTextures("outroWinSprite")[0]);
            this._winAnimation.anchor.set(0.5, 0.5);
            this._winAnimation.position.set(0, -96);
            this._infoPanel.addChild(this._winAnimation);
            this._loseLoop = this.createSpine("Outro_lose_Loop", [0, -96]);
            this._loseAnimation = this.createSpine("Outro_lose", [0, -96]);
            this._infoPanel.addChild(this._spinsPlayed);
            this._infoPanel.addChild(this._winCountUp);
        }
    }

    private resetGraphics():void {
        this._button.visible = false;
        this._spinsPlayed.visible = false;
        this._winPrince.renderable = false;
        this._loseLoop.renderable = false;
        this._winAnimation.visible = false;
        this._loseAnimation.renderable = false;
        this._winCountUp.visible = false;
    }

    public reset():void {
        this._winCountUp.visible = false;
        this._spinsPlayed.visible = false;
        if(this._coinRain) {
            this._coinRain.stop();
        }

        if(this._loseAnimation) {
            this._winAnimation.visible = false;
            this._winPrince.renderable = false;
            this._loseAnimation.renderable = false;
        }
    }
}
